// engagementPDF.js — browser adapter.
//
// The letter itself lives in src/shared/engagementLetter.mjs so the Node MCP
// server can generate a byte-identical document. This file only loads jsPDF
// from the CDN and turns the result into a blob, exactly as before.

import { buildEngagementLetterDoc, engagementFilename } from "./shared/engagementLetter.mjs";

const JSPDF_CDN = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";

async function loadJsPDF() {
  if (!window.jspdf) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = JSPDF_CDN;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return window.jspdf.jsPDF;
}

export async function generateEngagementLetterPDF(client, options = {}, staffSignatures = {}) {
  const { download = true, returnBlob = false } = options;

  const jsPDF = await loadJsPDF();
  const doc = buildEngagementLetterDoc(jsPDF, client, { staffSignatures });

  if (returnBlob) return doc.output("blob");

  if (download) {
    // Open in a new tab rather than downloading (unchanged behaviour).
    window.open(doc.output("bloburl"), "_blank");
  }
}

export { engagementFilename };
